import React from "react";
import ButtonOrang from "./ButtonOrang";

const BarrerasTecnologicas = () => (
  <section className="w-full bg-sidom-blue py-16 px-4 flex flex-col items-center justify-center">
    <div className="container leading-[1.3]   mt-[100px] mb-[100px] text-left">
      <h2 className="text-3xl md:text-4xl font-extrabold mb-6 text-sidom-orange">
        Eliminá barreras tecnológicas. Ganá eficiencia operativa y reducí costos
        de infraestructura.
      </h2>
      <p className="text-lg md:text-xl mb-10 text-sidom-light">
        Plataforma creada para atender la realidad del avance tecnológico y
        rapidez necesaria en la operativa diaria de los estudios aduaneros,
        buscando brindar la mayor eficiencia en los procesos internos,
        reduciendo errores y aumentando la calidad del servicio que prestan.
      </p>
      <ButtonOrang
        link="/misim-form"
        text="¡Quiero probar MiSIM!"
        background="bg-sidom-orange"
        textColor="text-sidom-light"
        bloke={true}
      />
    </div>
  </section>
);

export default BarrerasTecnologicas;
